// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"e18f0927","621":"0dd153ba","743":"9cfb79ac"}[chunkId] + ".chunk.js";
};